import styled from 'styled-components'
import { themeStyles } from '../../../styles/theme'

export const StyledTabLabel = styled.div`
  padding: 0.7rem 0.5rem;
  border-bottom: 1px solid ${themeStyles.colors.lightGreys[2].main};
  display: flex;
  align-items: center;
  gap: 0.2rem;
`

export const EmptyContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: ${themeStyles.colors.white.main};

  img {
    width: 80px;
    margin: auto;
  }

  div {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    justify-content: center;
    max-width: 250px;
  }
`

export const LoaderBox = styled.div`
  height: 100%;
  background: ${themeStyles.colors.white.main};
  display: flex;
  align-items: center;
  justify-content: center;
`
